import React from "react";
import { NavLink } from "react-router-dom";
import config from "../temp/config";
import styles from "../style/layout_components/Topbar.module.scss";
import { withSitecoreContext } from "@sitecore-jss/sitecore-jss-react";

// This is invoked from RouteHandler when Sitecore returns no valid route data.
// The NotFound component receives the Layout Service Context data, but no route data.
// This can be used to power parts of your site, such as navigation, from LS context additions
// without losing the ability to render them on your 404 pages :)

const Navigation = (props) => {
  const userName = props.sitecoreContext?.securityInfo?.userName;

  return (
    <div className={styles.topBar}>
      <div className={styles.topBarInner}>
        <NavLink to={config.virtualFolder} className={styles.topBarLogo}>
          <span>DELA</span>
        </NavLink>
      </div>
      <div id="username" className={styles.topBarService}>
        {userName}
      </div>
    </div>
  );
};

export default withSitecoreContext()(Navigation);
